<div class="d-flex flex-row justify-content-between align-items-center">
  <h5>{{ 'CASES.single.general.relation_list.proposals.heading' | translate }}</h5>
</div>
<div class="pt-4 pl-4" *ngIf="isLoading">
  <mat-spinner class="m-0 m-auto"></mat-spinner>
</div>
<app-empty-dataset [show]="!isLoading && !proposals?.length"></app-empty-dataset>
<mat-accordion multi>
  <mat-expansion-panel class="bg-light m-1" *ngFor="let proposal of proposals">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <p class="m-0">{{ 'SHARED.model.created_at' | translate }}:
          <b>{{ proposal.created_at | toDateObject | date: 'medium' }}</b>
        </p>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="d-flex">
      <a mat-raised-button color="primary" target="_blank" href="{{ storageUrl + proposal.location }}">
        {{ "CASES.single.general.relation_list.proposals.proposal_download" | translate }}
      </a>
    </div>
  </mat-expansion-panel>
</mat-accordion>
